import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmationComponent } from 'src/app/shared/confirmation/confirmation.component';

@Component({
  selector: 'app-quickbook-callback',
  templateUrl: './quickbook-callback.component.html',
  styleUrl: './quickbook-callback.component.scss'
})
export class QuickbookCallbackComponent {
  bsModalRef: BsModalRef | undefined;
  
  constructor(private _api: ApiService, private _router: Router, private modalService: BsModalService) {
    if (window.location.href.includes('code')) {
      this._api.api({param: window.location.href},'quickbooks/callback').subscribe(resp => {
        if (resp.flag === 200) {
          this.bsModalRef = this.modalService.show(ConfirmationComponent, {
            class: 'modal-dialog-centered'
          });
          this.bsModalRef.onHide?.subscribe(() => {
            this._router.navigate(['/app/dashboard'], { queryParams: { realmId: true } });
          })
        }
      })
    } else {
      this._router.navigate(['/app/dashboard']);
    }
  }
}
